import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ScrollProvider } from './context/ScrollContext';
import { useSmoothScroll } from './hooks/useSmoothScroll';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Blogs from './pages/Blogs';
import BlogPost from './pages/BlogPost';
import Jobs from './pages/SearchJobs';
import JobDetail from './pages/JobDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import { AuthProvider } from './context/AuthContext';
import AuthPrompt from './components/common/AuthPrompt';
import Disclaimer from './pages/Disclaimer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import CookieConsent from './components/common/CookieConsent';
import { HelmetProvider } from 'react-helmet-async';

// Wrapper component to handle scroll behavior 
const ScrollWrapper = ({ children }) => {
  useSmoothScroll();
  return children;
};

const AppContent = () => {
  const location = useLocation();

  // Scroll to top on route change
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <ScrollWrapper>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/search" element={<Jobs />} />
          <Route path="/jobs/:slug" element={<JobDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <CookieConsent />
    </ScrollWrapper>
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <Router basename="/" future={{ v7_relativeSplatPath: true }}>
        <AuthProvider>
          <AuthPrompt />
          <ScrollProvider>
            <AppContent />
          </ScrollProvider>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
};

export default App;
